<h2 class="dlg-title">Solicitar reporte Excel</h2>
<div class="dlg-body">
    <p>
        ¿Deseas solicitar la generación del archivo con los filtros y fechas seleccionados?
        Podrás revisar el estado en <strong>Exportaciones</strong>.
    </p>
</div>
<div class="dlg-actions">
    <button type="button" class="dlg-btn dlg-btn--ghost" mat-dialog-close>Cancelar</button>
    <button type="button" class="dlg-btn dlg-btn--primary" [mat-dialog-close]="true">Solicitar</button>
</div>
